import SHA256 from 'crypto-js/sha256';
import {canonicalSongIdentity} from './song-library-model';
import {prepareSearchDocument} from './song-search-model';

export const songIdentity = song => 'song:' + SHA256(canonicalSongIdentity(song)).toString();
export const libraryDocument = source => {
  const document = {...prepareSearchDocument(source), identityTitle: source.title || ''};
  return {...document, songKey: songIdentity(document),
    title: source.title || source.lyrics?.split(/\r?\n/).find(line => line.trim())?.trim().slice(0, 80) || 'Bez tytułu'};
};
